export default `
  mutation addUsersToEnterprisePlan($users: [StripeUserInput]!, $sendInvitationEmail: Boolean) {
    addUsersToEnterprisePlan(users: $users, sendInvitationEmail: $sendInvitationEmail) {
      success
      message
      quantityExceeded
      currentCount
      quantity
    }
  }
`
